import React from 'react'
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { BrowserRouter as Router, Switch, Route, useLocation } from "react-router-dom";
import Citas from './citas/citas'
import Expedientes from './expedientes/expedientes'
import Perfil from './perfil/perfil'
import icon from '../assets/Icon.png';
import { Footer, logout } from '../resources'
import { usuario } from '../resources'
import MainPacientes from './pacientes/main.pacientes';
import Escalas from '../escalas/escalasMenu';
import Balances from './balances/balances';
import Cortes from './cortes/main.cortes';
import GoogleTest from '../googleTest';
import EscalasEMT from './expedientes/visitas-details/escalas-emt';
import HojaRegistroEMT from './expedientes/visitas-details/hoja-registro-emt';
import { CalendarOutlined, DollarCircleOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';

const FINANCE_PATHS = ['/balances', '/cortes'];

function Navigator() {
  const { pathname } = useLocation();
  return (
    <Navbar bg="primary" variant="dark" expand="lg" sticky="top">
      <Container>
        <Navbar.Brand href="/" style={{ fontFamily: 'Poppins' }}>
          <img src={icon} width="40" height="35" className="d-inline-block align-top" alt="Recreamed logo" style={{ marginRight: 8 }} />
          Re-Crea Med
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="me-auto" activeKey={pathname}>
            <Nav.Link href="/pacientes" eventKey="/pacientes">
              <UserOutlined style={{ marginRight: 4 }} /> Pacientes
            </Nav.Link>
            <Nav.Link href="/citas" eventKey="/citas">
              <CalendarOutlined style={{ marginRight: 4 }} /> Citas
            </Nav.Link>
            <NavDropdown
              title={<><DollarCircleOutlined style={{ marginRight: 4 }} /> Finanzas</>}
              id="finanzas-dropdown"
              active={FINANCE_PATHS.includes(pathname)}
            >
              <NavDropdown.Item href="/balances">Balance</NavDropdown.Item>
              <NavDropdown.Item href="/cortes">Cortes</NavDropdown.Item>
            </NavDropdown>
          </Nav>
          <Nav>
            <NavDropdown
              title={<><UserOutlined style={{ marginRight: 6 }} />{usuario.name.split(' ')[0]}</>}
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.Item href="/perfil">Mi perfil</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={logout} style={{ color: '#dc3545' }}>
                <LogoutOutlined style={{ marginRight: 6 }} /> Cerrar sesión
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default function DoctorApp() {

  return (
    <Router>
      <Navigator />
      <Switch>

        <Route path="/pacientes">
          <MainPacientes />
        </Route>

        <Route path="/citas">
          <Citas />
        </Route>

        <Route path="/expedientes">
          <Expedientes />
        </Route>

        {/* <Route path="/Recetas">
          <Recetas />
        </Route> */}

        <Route path="/perfil">
          <Perfil />
        </Route>

        <Route path="/balances">
          <Balances />
        </Route>

        <Route path="/cortes">
          <Cortes />
        </Route>

        {/* Teporaty Google */}
        <Route path="/google">
          <GoogleTest />
        </Route>

        <Route path="/escalas">
          {/* This is taken from escalas directory*/}
          <Escalas />
        </Route>

        {/* For new expedient */}
        <Route path="/escalas-emt">
          <EscalasEMT />
        </Route>

        <Route path="/hoja-registro-emt">
          <HojaRegistroEMT />
        </Route>

        <Route path="/">
          <MainPacientes />
        </Route>

      </Switch>

      <Footer />
    </Router>
  )
}
